{
  "block_page_editor": {
    "add_comment": "Ajouter un commentaire",
    "untitled_placeholder": "Sans titre"
  },
  "block_page_list_menu_options": {
    "page_options_aria_label": "options de page",
    "long_menu_aria_controls": "menu-long",
    "delete_page_aria_label": "supprimer la page"
  },
  "block_page_list": {
    "add_page_aria_label": "ajouter une page",
    "page_names_aria_label": "noms des pages",
    "untitled_page": "Page sans titre",
    "add_page": "Ajouter une page"
  },
  "block_page_ui": {
    "loading_page_aria_label": "chargement de la page",
    "error_prefix": "Erreur : "
  },
  "task_with_section_block": {
    "add_task": "Ajouter une tâche",
    "task_name_empty_error": "Le nom de la tâche ne peut pas être vide",
    "add_task_error": "Une erreur inattendue s'est produite lors de l'ajout de la tâche.",
    "section_placeholder": "Tapez la section de tâche ou sélectionnez une section existante",
    "create_section_error": "Une erreur inattendue s'est produite lors de la création de la section.",
    "create_new_task_aria": "créer une nouvelle tâche",
    "add_task_to_section_aria": "Ajouter une tâche à la section",
    "toggle_dropdown_aria": "Basculer le menu déroulant de section",
    "section_title_aria": "titre de section"
  },
  "block_note_emoji_picker": {
    "add_emoji": "Ajouter un emoji"
  },
  "block_provider_editor": {
    "syncing": "Synchronisation..."
  },
  "remove_page": {
    "confirm_delete_title": "Êtes-vous sûr de vouloir supprimer cette page ?",
    "confirm_delete_content": "Cliquez sur le bouton confirmer pour supprimer la page."
  },
  "images_block": {
    "insert_image_url": "Insérer l'URL de l'image",
    "image_url": "URL de l'image",
    "image_url_placeholder": "Entrez l'URL de l'image",
    "image_url_required": "L'URL de l'image est requise.",
    "image_caption": "Légende de l'image",
    "image_caption_placeholder": "Entrez la légende de l'image",
    "insert_image": "Insérer l'image"
  },
  "contact_card_block": {
    "contact_required": "Le contact est requis",
    "contact": "Contact",
    "add_contact_card": "Ajouter une carte de contact",
    "add_contact_card_placeholder": "Ajouter une carte de contact par nom ou email"
  }
}
